import { render, staticRenderFns } from "./AppBtnCollapseGroup.vue?vue&type=template&id=4c120ce0&scoped=true&"
import script from "./AppBtnCollapseGroup.vue?vue&type=script&lang=ts&"
export * from "./AppBtnCollapseGroup.vue?vue&type=script&lang=ts&"
import style0 from "./AppBtnCollapseGroup.vue?vue&type=style&index=0&id=4c120ce0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c120ce0",
  null
  
)

export default component.exports